import { Component, Input } from '@angular/core';
import { Panel } from 'app/utils/panel';

@Component({
    selector: 'i360-csf-warning',
    template: `
        <i360-whole-page-error>
            <ng-container title>
                {{ 'utils.csf.title' | translate: {listName: listName} }}
            </ng-container>
            <ng-container note *ngIf="panel.isCpanel">
                {{ 'utils.csf.note' | translate: {listName: listName} | translateCut:0}}
                <a href="../../../cgi/configserver/csf.cgi" class="i360-dashboard-link">
                    {{ 'utils.csf.note' | translate: {listName: listName} | translateCut:1}}
                </a>
                {{ 'utils.csf.note' | translate: {listName: listName} | translateCut:2}}
            </ng-container>
        </i360-whole-page-error>
    `,
})
export class CsfComponent {
    @Input() listName: string;

    constructor(public panel: Panel) {}
}
